import Vue from 'vue';
import Vuex from 'vuex';

import UsersModule from "./modules/users.module"
import AuthModule from "./modules/auth.module"
import LdapSyncModule from "./modules/ldapsync.module";
import ProjectsModule from "./modules/projects.module";
import RolesModule from "./modules/roles.module";
import externalProjectModule from "./modules/externalProject.module";
import FlycoModule from "./modules/flyco.module";
import PageModule from "./modules/pages.module";


Vue.use(Vuex);
const store = new Vuex.Store();

store.registerModule("auth", AuthModule);
store.registerModule("users", UsersModule);
store.registerModule("ldapsync", LdapSyncModule);
store.registerModule("projects", ProjectsModule);
store.registerModule("roles", RolesModule);
store.registerModule("externalProject", externalProjectModule);
store.registerModule("flyco",FlycoModule);
store.registerModule("pages",PageModule);

export default store
